import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconText2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"text-2"} maskId="square-filled-radius-0-stroke-1-IconText2"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V4H12.5V21H11.5V4H3V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconText2;
